import api from '../..'
import { faker } from '@faker-js/faker'

var fakerData = [...Array(20)].map((v, index) => {
    return {
        id: index + 1,
        firstName: faker.person.firstName(),
        lastName: faker.person.lastName(),
        homePhone: faker.phone.number(),
        workPhone: faker.phone.number(),
        mobilePhone: faker.phone.number(),
        address: faker.location.streetAddress(),
        emailAddress: faker.internet.email(),
        medicareNumber: faker.datatype.number({ min: 1000, max: 9999 })
    }
})
var fakerAddress = {
    SubPremise: faker.location.secondaryAddress(),
    StreetAddress: faker.location.streetAddress(),
    Suburb: faker.location.city(),
    State: faker.location.state(),
    Postcode: faker.location.zipCode(),
    Location: faker.location.nearbyGPSCoordinate(),
    GNAF: faker.location.county(),
    Country: faker.location.country()
}
var fakerResponse = {
    data: fakerData
}

const requests = {
    create: async ({
        firstName,
        lastName,
        homePhone,
        workPhone,
        mobilePhone,
        address,
        emailAddress,
        medicareNumber,
        dateOfBirth,
        genderId,
        indigenousId,
        isDeceased,
        dateOfDeath,
        hasPensionCard,
        pensionCardNumber,
        otherDetails,
        approvalGrantedDate,
        additionalNotes,
        isDeleted,
        diseases
    }) => {
        var response = await api.post(`/maarima/Patient`, {
            firstName,
            lastName,
            homePhone,
            workPhone,
            mobilePhone,
            address,
            emailAddress,
            medicareNumber,
            dateOfBirth,
            genderId,
            indigenousId,
            isDeceased,
            dateOfDeath,
            hasPensionCard,
            pensionCardNumber,
            otherDetails,
            approvalGrantedDate,
            additionalNotes,
            isDeleted,
            diseases
        })

        return response.data
    },
    update: async ({
        id,
        firstName,
        lastName,
        homePhone,
        workPhone,
        mobilePhone,
        address,
        emailAddress,
        medicareNumber,
        indigenousId,
        isDeceased,
        genderId,
        dateOfDeath,
        hasPensionCard,
        pensionCardNumber,
        otherDetails,
        approvalGrantedDate,
        additionalNotes,
        isDeleted,
        diseases
    }) => {
        var response = await api.put(`/maarima/Patient/${id}`, {
            id,
            firstName,
            lastName,
            homePhone,
            workPhone,
            mobilePhone,
            address,
            emailAddress,
            medicareNumber,
            indigenousId,
            isDeceased,
            genderId,
            dateOfDeath,
            hasPensionCard,
            pensionCardNumber,
            otherDetails,
            approvalGrantedDate,
            additionalNotes,
            isDeleted,
            diseases
        })

        return response.data
    },

    fetch: async ({ search, sortKey, sortType, pageSize, pageNo }) => {
        var response = await api.get(`/maarima/Patient`, {
            params: {
                search,
                sortKey,
                sortType,
                pageSize,
                pageNo
            }
        })
        return response.data

        //start Faker
        //return fakerResponse
        //end Faker
    },
    fetchById: async (id) => {
        var response = await api.get(`/maarima/Patient/${id}`)
        return response.data

        //start Faker
        //return fakerResponse.data.filter((v) => v.id == id)[0]
        //end Faker
    }
}

export default requests
